import {SettingsParamType, createSettingsParams} from '@wix/tpa-settings'
import {EventDetailsAlignment} from '@wix/wix-events-commons-statics'

export type ISettingsParams = {
  scheduleTitleText: SettingsParamType.Text
  buttonText: SettingsParamType.Text
  readMore: SettingsParamType.Text
  readLess: SettingsParamType.Text
  /**
   * @deprecated moved to styles
   */
  showDateAndLocation: boolean
  /**
   * @deprecated moved to styles
   */
  showButton: boolean
  /**
   * @deprecated moved to styles
   */
  showFilters: boolean
  /**
   * @deprecated moved to styles
   */
  showDuration: boolean
  /**
   * @deprecated moved to styles
   */
  buttonStyle: number
  /**
   * @deprecated moved to styles
   */
  headerTextAlignment: number
  scheduleTitleTag: SettingsParamType.Text
  dateDividerTag: SettingsParamType.Text
  scheduleItemTitleTag: SettingsParamType.Text
}

export enum BUTTON_STYLE {
  HOLLOW = 1,
  HOLLOW_ROUNDED = 2,
  FULL = 3,
  FULL_ROUNDED = 4,
}

export const isFullButtonStyle = (buttonStyle: BUTTON_STYLE) =>
  [BUTTON_STYLE.FULL, BUTTON_STYLE.FULL_ROUNDED].includes(buttonStyle)

export const isRoundedButtonStyle = (buttonStyle: BUTTON_STYLE) =>
  [BUTTON_STYLE.HOLLOW_ROUNDED, BUTTON_STYLE.FULL_ROUNDED].includes(buttonStyle)

const settingsParams = createSettingsParams<ISettingsParams>({
  scheduleTitleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('defaults.scheduleTitleText'),
  },
  buttonText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('defaults.buttonText'),
  },
  readMore: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('defaults.readMoreText'),
  },
  readLess: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('defaults.readLessText'),
  },
  /* When getting rid of settings params for good, move defaults to styles */
  /**
   * @deprecated moved to styles
   */
  showDateAndLocation: {
    getDefaultValue: () => true,
  },
  /**
   * @deprecated moved to styles
   */
  showFilters: {
    getDefaultValue: () => true,
  },
  /**
   * @deprecated moved to styles
   */
  showButton: {
    getDefaultValue: () => true,
  },
  /**
   * @deprecated moved to styles
   */
  showDuration: {
    getDefaultValue: () => true,
  },
  /**
   * @deprecated moved to styles
   */
  buttonStyle: {
    getDefaultValue: () => BUTTON_STYLE.HOLLOW,
  },
  /**
   * @deprecated moved to styles
   */
  headerTextAlignment: {
    getDefaultValue: () => EventDetailsAlignment.LEFT,
  },
  scheduleTitleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h1',
  },
  dateDividerTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h2',
  },
  scheduleItemTitleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h3',
  },
})

export default settingsParams
